import(/* webpackMode: "eager", webpackExports: ["Blog"] */ "/app/site/src/app/[lang]/(public)/blog/blog.tsx");
